module.exports = __webpack_public_path__ + "img/item7.f76bce75.png";